import "core-js/modules/es.array.includes.js";
import { ElMessage } from "element-plus";
import { get_music, get_music_all, music_grade, music_search, music_rank } from "@/api/music";
import { onMounted, reactive, toRefs, ref, onDeactivated, nextTick, computed } from "vue";
const NAV_TABS = [{
  key: "recommend",
  label: "推荐"
}, {
  key: "rank",
  label: "排行"
}, {
  key: "like",
  label: "喜欢"
}, {
  key: "playlist",
  label: "播放列表"
}, {
  key: "search",
  label: "搜索"
}];
const MODE_LABELS = ["顺序播放", "全部循环", "单曲循环", "随机播放"];
export default {
  name: "home_name",

  setup() {
    let lyricInterval = null;
    let searchValue = ref("");
    let lyricTimer = ref(0);
    let lyricIdx = ref(0);
    let clickClientX = ref(0);
    let activeNav = ref("recommend");
    let showLyricView = ref(false);
    let displayList = ref([]);
    let listLoading = ref(false);
    let currentTime = ref(0);
    let duration = ref(0);
    let serCurPage = ref(1);
    const pageSize = ref(10);
    const serDisabled = ref(false);
    const serCount = ref(0);
    let musicAllCache = null;
    let listLoadSeq = 0;
    const likedIds = ref(new Set());
    let songData = reactive({
      status: false,
      index: 0,
      singer: null,
      title: null,
      img: null,
      src: "",
      lyric: [],
      music_list: [],
      mode_idx: 1
    });
    const navTabs = NAV_TABS;
    const modeLabels = MODE_LABELS;
    const currentNavLabel = computed(() => {
      return NAV_TABS.find(t => t.key === activeNav.value)?.label || "";
    });
    const emptyListText = computed(() => {
      const map = {
        recommend: "暂无推荐歌曲",
        rank: "暂无排行数据",
        like: "还没有喜欢的歌曲，播放时点赞即可收藏",
        playlist: "播放列表为空，可从搜索添加歌曲"
      };
      return map[activeNav.value] || "暂无数据";
    });
    const showAddAllBtn = computed(() => ["recommend", "rank", "like"].includes(activeNav.value));

    function parseLyric(raw) {
      if (!raw) return [];
      if (Array.isArray(raw)) return raw;

      try {
        return JSON.parse(raw);
      } catch {
        return [];
      }
    }

    function fetchMusicAll() {
      if (musicAllCache) return Promise.resolve(musicAllCache);
      return get_music_all().then(res => {
        if (res.data.code === 200 && res.data.result?.list) {
          musicAllCache = res.data.result.list;
        }

        return musicAllCache || [];
      });
    }

    function enrichSong(song) {
      if (!song?.id) return Promise.resolve(song);
      return fetchMusicAll().then(list => {
        const full = list.find(m => m.id === song.id);
        return full ? { ...full,
          ...song
        } : song;
      });
    }

    function fillLyricIfMissing(current) {
      if (!current?.id || parseLyric(current.lyric).length > 0) return;
      enrichSong(current).then(full => {
        if (full.lyric) {
          current.lyric = full.lyric;
          current.pic = full.pic ?? current.pic;
          songData.lyric = parseLyric(full.lyric);
          songData.img = current.pic ?? songData.img;
        }
      });
    }

    function formatTime(sec) {
      if (!sec || isNaN(sec)) return "0:00";
      const m = Math.floor(sec / 60);
      const s = Math.floor(sec % 60);
      return `${m}:${s.toString().padStart(2, "0")}`;
    }

    function onTimeUpdate() {
      const music = document.getElementById("audio");
      if (music) currentTime.value = music.currentTime;
    }

    function onLoadedMetadata() {
      const music = document.getElementById("audio");
      if (music) duration.value = music.duration || 0;
    }

    function seekProgress(e) {
      const music = document.getElementById("audio");

      if (music) {
        music.currentTime = Number(e.target.value);
        currentTime.value = music.currentTime;
      }
    }

    function isPlayingItem(music) {
      const current = songData.music_list[songData.index];
      return current && current.id === music.id && songData.status;
    }

    function switchNav(nav) {
      activeNav.value = nav;
      showLyricView.value = false;
      listLoadSeq++;
      displayList.value = [];
      listLoading.value = nav === "recommend" || nav === "rank";
      if (nav === "recommend") loadRecommendList();else if (nav === "rank") loadRankList();else if (nav === "like") loadLikeList();else if (nav === "playlist") loadPlaylistList();else listLoading.value = false;
    }

    function loadRecommendList() {
      const seq = ++listLoadSeq;
      listLoading.value = true;
      displayList.value = [];
      get_music().then(res => {
        if (seq !== listLoadSeq) return;

        if (res.data.code === 200 && res.data.result?.list) {
          displayList.value = res.data.result.list;
        }
      }).finally(() => {
        if (seq === listLoadSeq) listLoading.value = false;
      });
    }

    function loadRankList() {
      const seq = ++listLoadSeq;
      listLoading.value = true;
      displayList.value = [];
      music_rank().then(res => {
        if (seq !== listLoadSeq) return;

        if (res.data.code === 200 && res.data.result?.list) {
          displayList.value = res.data.result.list;
        }
      }).finally(() => {
        if (seq === listLoadSeq) listLoading.value = false;
      });
    }

    function loadLikeList() {
      const raw = localStorage.getItem("LOCAL_LIKED_MUSIC");
      displayList.value = raw ? JSON.parse(raw) : [];
      syncLikedIds();
    }

    function loadPlaylistList() {
      const raw = localStorage.getItem("LOCAL_MUSIC_LIST");
      displayList.value = raw ? JSON.parse(raw) : [];
    }

    function syncLikedIds() {
      const list = JSON.parse(localStorage.getItem("LOCAL_LIKED_MUSIC") || "[]");
      likedIds.value = new Set(list.map(m => m.id));
    }

    function isLiked(music) {
      return music?.id != null && likedIds.value.has(music.id);
    }

    function toggleLike(music) {
      if (!music?.id) return;
      let list = JSON.parse(localStorage.getItem("LOCAL_LIKED_MUSIC") || "[]");
      const idx = list.findIndex(m => m.id === music.id);

      if (idx >= 0) {
        list.splice(idx, 1);
        localStorage.setItem("LOCAL_LIKED_MUSIC", JSON.stringify(list));
        syncLikedIds();
        if (activeNav.value === "like") loadLikeList();
        showMessage("已取消喜欢");
        return;
      }

      enrichSong(music).then(full => {
        list.unshift(full);
        localStorage.setItem("LOCAL_LIKED_MUSIC", JSON.stringify(list));
        syncLikedIds();
        if (activeNav.value === "like") loadLikeList();
        showMessage("已添加到喜欢");
      });
    }

    function playFromDisplayList(idx) {
      songData.music_list = [...displayList.value];
      songData.index = idx;
      change_music();
      resetPlayStyle();
      setMusicState(true);
    }

    function end_music() {
      if (songData.mode_idx === 0) {
        if (songData.index < songData.music_list.length - 1) {
          songData.index++;
          change_music();
          resetPlayStyle();
          setMusicState(true);
        } else {
          setMusicState(false);
        }
      } else if (songData.mode_idx === 1) {
        songData.index = songData.index < songData.music_list.length - 1 ? songData.index + 1 : 0;
        change_music();
        resetPlayStyle();
        setMusicState(true);
      } else if (songData.mode_idx === 2) {
        resetPlayStyle();
        setMusicState(true);
      } else {
        songData.index = Math.floor(Math.random() * songData.music_list.length);
        change_music();
        resetPlayStyle();
        setMusicState(true);
      }
    }

    function huaDong(e) {
      const moveX = e.clientX - clickClientX.value;
      if (moveX < -80) playNext();else if (moveX > 80) playLast();
    }

    function anXia(e) {
      clickClientX.value = e.clientX;
    }

    function searchFn() {
      if (searchValue.value === "") {
        showMessage("搜索词为空", "error");
        return;
      }

      const seq = ++listLoadSeq;
      listLoading.value = true;
      displayList.value = [];
      music_search({
        search_value: searchValue.value,
        page_index: serCurPage.value
      }).then(res => {
        if (seq !== listLoadSeq) return;

        if (res.data.code === 200) {
          displayList.value = res.data.result?.list || [];
          serCount.value = res.data.result?.total_num || displayList.value.length * 10;
        }
      }).finally(() => {
        if (seq === listLoadSeq) listLoading.value = false;
      });
    }

    function handleCurrentChange(val) {
      serCurPage.value = val;
      searchFn();
    }

    function saveToLikedList(song) {
      if (!song?.id) return;
      let list = JSON.parse(localStorage.getItem("LOCAL_LIKED_MUSIC") || "[]");

      if (!list.find(m => m.id === song.id)) {
        list.unshift(song);
        localStorage.setItem("LOCAL_LIKED_MUSIC", JSON.stringify(list));
        syncLikedIds();
        if (activeNav.value === "like") loadLikeList();
      }
    }

    function music_zan() {
      const current = songData.music_list[songData.index];
      if (!current) return;
      music_grade({
        music_id: current.id,
        grade: 1
      }).then(() => {
        showMessage("点赞成功");
        saveToLikedList(current);
      });
    }

    function music_cai() {
      const current = songData.music_list[songData.index];
      if (!current) return;
      music_grade({
        music_id: current.id,
        grade: 2
      }).then(() => {
        showMessage("已记录");
      });
    }

    function change_music() {
      const current = songData.music_list[songData.index];
      if (!current) return;
      songData.singer = current.music_singer;
      songData.title = current.music_name;
      songData.img = current.pic ?? "https://manage1.hej6666.cn/public/musicImg/defalut.jpeg";
      songData.src = current.music_src;
      songData.lyric = parseLyric(current.lyric);
      document.title = `${songData.singer} ${songData.title}`;
      lyricTimer.value = 0;
      lyricIdx.value = 0;
      currentTime.value = 0;
      duration.value = 0;
      enrichSong(current).then(full => {
        if (full.pic) {
          current.pic = full.pic;
          songData.img = full.pic;
        }

        if (full.lyric && !parseLyric(current.lyric).length) {
          current.lyric = full.lyric;
          songData.lyric = parseLyric(full.lyric);
        }
      });
    }

    function nextModel() {
      songData.mode_idx = (songData.mode_idx + 1) % 4;
      showMessage(modeLabels[songData.mode_idx]);
    }

    function showMessage(msg, type = "success") {
      ElMessage({
        message: msg,
        type,
        center: true,
        offset: 50
      });
    }

    onMounted(() => {
      const music = document.getElementById("audio");
      if (music) music.pause();
      clearInterval(lyricInterval);
      syncLikedIds();
      loadRecommendList();
    });
    onDeactivated(() => clearInterval(lyricInterval));

    function lyricAutoSpin() {
      clearInterval(lyricInterval);
      lyricInterval = setInterval(() => {
        const music = document.getElementById("audio");
        if (!music || songData.lyric.length <= 0) return;
        const lyric_data = document.getElementById("lyric");
        if (!lyric_data) return;
        lyricTimer.value = Math.round(music.currentTime * 10);
        songData.lyric.forEach((element, idx) => {
          if (Math.round(element.time * 10) === lyricTimer.value) {
            lyricIdx.value = idx;
            const showIdx = idx < 3 ? 0 : idx - 3;
            const firstChild = lyric_data.children[0];

            if (firstChild) {
              lyric_data.scrollTop = showIdx * (firstChild.offsetHeight + 16);
            }
          }
        });
      }, 100);
    }

    function setMusicState(bool) {
      const music = document.getElementById("audio");
      if (!music) return;

      if (bool) {
        songData.status = true;
        nextTick(() => {
          music.play().then(() => lyricAutoSpin()).catch(() => {
            songData.status = false;
          });
        });
      } else {
        songData.status = false;
        music.pause();
        clearInterval(lyricInterval);
      }
    }

    function resetPlayStyle() {
      clearInterval(lyricInterval);
      const lyric_data = document.getElementById("lyric");
      if (lyric_data) lyric_data.scrollTop = 0;
    }

    function getPlaylist() {
      return JSON.parse(localStorage.getItem("LOCAL_MUSIC_LIST") || "[]");
    }

    function savePlaylist(list) {
      localStorage.setItem("LOCAL_MUSIC_LIST", JSON.stringify(list));
    }

    function addSongToPlaylist(item, silent = false) {
      if (!item?.id) return Promise.resolve(false);
      const list = getPlaylist();

      if (list.find(m => m.id === item.id)) {
        if (!silent) showMessage("已经在播放列表中了", "warning");
        return Promise.resolve(false);
      }

      return enrichSong(item).then(full => {
        list.push(full);
        savePlaylist(list);
        if (activeNav.value === "playlist") loadPlaylistList();
        if (!silent) showMessage("已加入播放列表");
        return true;
      });
    }

    function addMusicList(key) {
      addSongToPlaylist(displayList.value[key]);
    }

    function addAllToPlaylist() {
      if (!displayList.value.length) {
        showMessage("当前列表为空", "warning");
        return;
      }

      const existing = getPlaylist();
      const existingIds = new Set(existing.map(m => m.id));
      const toAdd = displayList.value.filter(m => !existingIds.has(m.id));

      if (!toAdd.length) {
        showMessage("当前列表歌曲已全部在播放列表中", "warning");
        return;
      }

      Promise.all(toAdd.map(s => enrichSong(s))).then(enriched => {
        savePlaylist([...existing, ...enriched]);
        showMessage(`已添加 ${enriched.length} 首到播放列表`);
      });
    }

    function playLast() {
      if (songData.mode_idx === 3) {
        songData.index = Math.floor(Math.random() * songData.music_list.length);
      } else {
        songData.index = songData.index > 0 ? songData.index - 1 : songData.music_list.length - 1;
      }

      change_music();
      resetPlayStyle();
      setMusicState(true);
    }

    function playNext() {
      if (songData.mode_idx === 3) {
        songData.index = Math.floor(Math.random() * songData.music_list.length);
      } else if (songData.mode_idx === 0) {
        if (songData.index >= songData.music_list.length - 1) {
          setMusicState(false);
          return;
        }

        songData.index++;
      } else {
        songData.index = songData.index < songData.music_list.length - 1 ? songData.index + 1 : 0;
      }

      change_music();
      resetPlayStyle();
      setMusicState(true);
    }

    function delMusicFromList(idx) {
      const delData = displayList.value.splice(idx, 1);
      localStorage.setItem("LOCAL_MUSIC_LIST", JSON.stringify(displayList.value));

      if (delData[0]?.id === songData.music_list[songData.index]?.id) {
        if (displayList.value.length) {
          songData.music_list = [...displayList.value];
          songData.index = Math.min(songData.index, displayList.value.length - 1);
          change_music();
        } else {
          songData.music_list = [];
          songData.title = null;
          songData.singer = null;
          setMusicState(false);
        }
      }
    }

    return { ...toRefs(songData),
      navTabs,
      modeLabels,
      activeNav,
      showLyricView,
      displayList,
      listLoading,
      currentTime,
      duration,
      searchValue,
      serCurPage,
      pageSize,
      serDisabled,
      serCount,
      lyricTimer,
      lyricIdx,
      currentNavLabel,
      emptyListText,
      showAddAllBtn,
      switchNav,
      loadRecommendList,
      playFromDisplayList,
      isPlayingItem,
      isLiked,
      toggleLike,
      formatTime,
      onTimeUpdate,
      onLoadedMetadata,
      seekProgress,
      end_music,
      huaDong,
      anXia,
      searchFn,
      handleCurrentChange,
      music_zan,
      music_cai,
      nextModel,
      setMusicState,
      playLast,
      playNext,
      addMusicList,
      addAllToPlaylist,
      delMusicFromList
    };
  }

};